import { Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { HttpService } from '../services/http.service';

export namespace EnumBi {
    export class Rest {
        constructor(private httpService: HttpService) { }

        public getBancos(): Observable<Response> {
            return this.httpService.pathRest().get('enum/bancos/', true);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/resources/bi/enum.bi.ts